if (libraries.knockoutValidation) {
  ko.validation.rules.uri = {
    validator: function(value, options) {
      var pattern, scheme, type;
      options = $.extend({}, options);
      scheme = options.scheme;
      pattern = value.match(/(https?|ftp)\:\/\/([a-z0-9\-.]*)\.([a-z]{2,3})(\:[0-9]{2,5})?(\/([a-z0-9+\$_\-]\.?)+)*\/?/i);
      type = scheme ? value.substring(0, value.indexOf(':')).toLowerCase() === scheme.toLowerCase() : true;
      return pattern && type;
    },
    message: 'Please enter a valid uri'
  };
}
